import { Button } from 'reactstrap';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { SurveyStatsFiltersProps, type SurveyStatsStatus } from '../types';
import { SURVEY } from '@constants/terminology';
import { DashboardRow } from '@g17eco/molecules/dashboard';
import type { FilterOptionsMap } from './constants';
import type { DataPeriods } from '@utils/dataPeriods';

interface Props {
  filterOptions: FilterOptionsMap;
  filters: SurveyStatsFiltersProps;
  onMultiSelectChange: (data: Partial<SurveyStatsFiltersProps>) => void;
  onSaveFilters: () => void;
}

export const SurveyStatsFilters = (props: Props) => {
  const { filterOptions, filters, onMultiSelectChange, onSaveFilters } = props;

  return (
    <DashboardRow classes={{ children: 'flex-lg-column' }}>
      <div className='d-flex gap-2 mb-2'>
        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder='Month'
          className='w-100'
          onChange={(values) => onMultiSelectChange({ months: values })}
          options={filterOptions.months}
          values={filters.months || []}
        />

        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder='Year'
          className='w-100'
          onChange={(values) => onMultiSelectChange({ years: values })}
          options={filterOptions.years}
          values={filters.years || []}
        />

        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder='Period'
          className='w-100'
          onChange={(values) => onMultiSelectChange({ periods: values as DataPeriods[] })}
          options={filterOptions.periods}
          values={filters.periods || []}
        />
      </div>
      <div className='d-flex gap-2 mb-2'>
        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder={`${SURVEY.CAPITALIZED_SINGULAR} Status`}
          className='w-100'
          onChange={(values) => onMultiSelectChange({ surveyStatuses: values as SurveyStatsStatus[] })}
          options={filterOptions.surveyStatuses}
          values={filters.surveyStatuses || []}
        />
        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder='Subsidiaries'
          className='w-100'
          onChange={(values) => onMultiSelectChange({ initiatives: values })}
          options={filterOptions.initiatives}
          values={filters.initiatives || []}
          isFullWidthOptions
        />
        <Button color='primary' className='text-nowrap' size='sm' onClick={onSaveFilters}>
          <i className='fal fa-floppy-disk mr-2' />
          Save filters
        </Button>
      </div>
    </DashboardRow>
  );
};
